// extracted by mini-css-extract-plugin
module.exports = {"badgesContainer":"styles_badgesContainer__2UsOo","badgesItem":"styles_badgesItem__3JeDi","badgesItemTitle":"styles_badgesItemTitle__qP0dQ","comingSoon":"styles_comingSoon__2nj76"};